import { memo } from 'react';
import { Box, Menu, MenuItem, MenuProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SortTableAscIcon, SortTableDescIcon } from '~/assets/icons';
import { SortDirection } from '~/utils/types/common';

type MenuSortDirectionProps = MenuProps & {
  active: SortDirection | undefined;
  onSelectAscDirection: () => void;
  onSelectDescDirection: () => void;
};

const MenuSortDirection = (props: MenuSortDirectionProps) => {
  const { active, onSelectAscDirection, onSelectDescDirection, ...restProps } = props;

  const { t } = useTranslation('admin/common');

  return (
    <Menu
      id={`sort-direction-menu`}
      className='flex w-full'
      keepMounted
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 20,
      }}
      {...restProps}
    >
      <MenuItem onClick={onSelectAscDirection} selected={active === 'ASC'}>
        <Box className='flex flex-row items-center p-[6px] w-[169px]'>
          <SortTableAscIcon className='w-[18px] h-[18px]' />
          <Box className='ml-[6px] text-[14px]/[16.8px] font-normal text-[#5A6385]'>{t('sortDirection.asc')}</Box>
        </Box>
      </MenuItem>
      <MenuItem onClick={onSelectDescDirection} className='mt-[10px]' selected={active === 'DESC'}>
        <Box className='flex flex-row items-center p-[6px] w-[169px] '>
          <SortTableDescIcon className='w-[18px] h-[18px]' />
          <Box className='ml-[6px] text-[14px]/[16.8px] font-normal text-[#5A6385]'>{t('sortDirection.desc')}</Box>
        </Box>
      </MenuItem>
    </Menu>
  );
};

export default memo(MenuSortDirection);
